import { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../ContextAuth/Context';
import { getToken } from '../utils';

export const Currencies = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [currencys, setCurrencys] = useState([]);
  const [countrys, setCountrys] = useState([]);
  const [transactionMethods, setTransactionMethods] = useState([]);
  const [accountTypes, setAccountTypes] = useState([]);

  const userToken = getToken()?.token;

  useEffect(() => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_BASE_URL}/dashboard/all-settings`;
      setIsLoading(true);
      try {
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${userToken}` },
        });
        setTransactionMethods(response.data.transaction_methods);
        setCurrencys(response.data.currencies);
        setCountrys(response.data.countrys);
        setAccountTypes(response.data.account_types);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [userToken]);

  return { currencys, countrys, accountTypes, transactionMethods };
};
